import produce from '../../produce';

import * as types from './types';

const initialState = {
  index: 0
};

/* eslint-disable consistent-return */
/* eslint-disable default-case */
/* eslint-disable no-param-reassign */
const reducer = produce((draft, action) => {
  switch (action.type) {
    case types.ACTIVE_PROMO_TOGGLE:
      draft.index = action.index;
      break;
  }
}, initialState);

export default reducer;
